import React from 'react';
import '../styles/Modal.css';

interface DeleteConfirmModalProps {
  isOpen: boolean;
  categoryName: string;
  onConfirm: () => void;
  onCancel: () => void;
  isDeleting?: boolean;
  errorMessage?: string | null;
}

export function DeleteConfirmModal({
  isOpen,
  categoryName,
  onConfirm,
  onCancel,
  isDeleting = false,
  errorMessage = null,
}: DeleteConfirmModalProps): JSX.Element | null {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay" role="dialog" aria-modal="true">
      <div className="modal-box modal-box--confirm" dir="rtl">
        <h2 className="modal-title">מחיקת קטגוריה</h2>
        {errorMessage && (
          <div className="api-error-message">{errorMessage}</div>
        )}
        <p className="confirm-message">
          האם אתה בטוח שברצונך למחוק את{' '}
          <strong>&ldquo;{categoryName}&rdquo;</strong>? פעולה זו אינה הפיכה.
        </p>
        <div className="modal-actions">
          <button
            type="button"
            className="btn-secondary"
            onClick={onCancel}
            disabled={isDeleting}
          >
            ביטול
          </button>
          <button
            type="button"
            className="btn-danger"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? 'מוחק...' : 'מחק'}
          </button>
        </div>
      </div>
    </div>
  );
}
